import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {MessageDto} from "../../../../auto-generated-server-dtos/claim/messages/message-dto";
import {environment} from "../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ListMessagesService {

  constructor(private httpClient: HttpClient) { }

  listMessages(claimId: number) : Observable<MessageDto[]> {
    return this.httpClient.get<MessageDto[]>(`${environment.apiServer}/ListMessages?claimId=${claimId}`);
  }
}
